import React, { useState, useEffect } from 'react';
import { useHistory, useParams } from "react-router-dom";
import rightArrow from '../../../Assets/Announcement/Assets-Desktop/arrow_right.svg';
import billlading from '../../../Assets/ContainerStatus/Assets_Desktop/bill-of-lading.svg';
import '../../../css/ContainerStatus/ContainerStatusBillOfLading.css';
import Header from '../../Shared/Header';
import Footer from '../../Shared/Footer';
import Footer2 from '../../Shared/Footer2';
import MetaDecorator from '../../../ReactHelmet/MetaDecorator';
import TitleDescription from '../../../Data/Shared/TitleDescription.json';
import { ApiCall } from '../../../Services/utils/ApiCall';
import { trackingBaseURL } from '../../../Services/config/apiGateway';
import { BILLOFLADING_DETAILS_ENDPOINT } from '../../../Services/config/apiEndPoints';
import { success } from '../../../Redux/_actions/container.actions';
import { useDispatch, useSelector } from 'react-redux';

const ContainerStatusBillOfLading = props => {
    let history = useHistory();
    const paramObj = useParams();
    const dispatch = useDispatch();
    const containerDataR = useSelector(state => state.containerReducer.data);
    const [billOfLadingNumber, setBillOfLadingNumber] = useState('');
    const [allBillData, setAllBillData] = useState([]);
    const [noRecord, setNoRecord] = useState(true);
    const onHandleCard = (event) => {
        allBillData?.find((name) => {
            if (name?.containerNumber === allBillData[event]?.containerNumber) {
                const dataBL = { containerNumberLS: name?.name, billOfLadingNumberLS: containerDataR?.billOfLadingNumberLS, containerTerminalNameLS: containerDataR?.containerTerminalNameLS }
                dispatch(success(dataBL));
                history.push({
                    pathname: `/containerTrip/${name?.containerNumber}`,
                });
            }
        })
    }
    useEffect(() => {
        const data = { containerNumberLS: '', billOfLadingNumberLS: containerDataR?.billOfLadingNumberLS, containerTerminalNameLS: containerDataR?.containerTerminalNameLS }
        dispatch(success(data));
        const { billOfLadingNum } = paramObj;
        setBillOfLadingNumber(billOfLadingNum);
        ApiCall(
            'GET',
            trackingBaseURL + BILLOFLADING_DETAILS_ENDPOINT + `?billOfLading=${billOfLadingNum}`,
            {},
            {
                Accept: 'application/json',
                'Content-Type': 'application/json',
            },
        ).then((apiData) => {
            if (apiData.flag != -1) {
                if (apiData.flag == "500") {
                    console.log('I am 500!');
                    setNoRecord(false);
                }
                else {
                    console.log('I am 200!');
                    setAllBillData(apiData);
                }
            } else {
                setNoRecord(false);
            }
        });
    }, []);
    return (
        <div class="csoutercolor" >
            <MetaDecorator title={TitleDescription.billOfLadingPageTitle} description={TitleDescription.billOfLadingPageDescription} />
            <Header  tilesFetched = {()=>{}}/>
            <div className='weathernavbar'>
                <small id="weathername">Container Status </small>
            </div><hr className='navbarhr' />
            <div id="topsection">
                <div id="topimg"><img src={billlading} width="24" height="28" class=" pt-1" alt="" loading="lazy" /></div>
                <small id="bill">Bill of Lading</small>
                <small id="number">{billOfLadingNumber}</small>
            </div>
            <div className="BillOfLadingSectionPart">
                {noRecord ?
                    <div class="csmobilewidth">
                        {
                            (allBillData?.map((name, index) => {
                                return (
                                    <div key={index} onClick={() => onHandleCard(index)}>
                                        {index < (allBillData.length / 2) && <div className='cs2card1'>
                                            <small id="ContainerNo">Container No.</small>
                                            <div className='cs2terminalNameCol1'>
                                                {name?.containerNumber}
                                                <a id="arrowleft"><img src={rightArrow} width="23" height="23" class=" pt-1" alt="" loading="lazy" /></a>
                                            </div>
                                        </div>
                                        }
                                    </div>
                                );
                            }))
                        }
                    </div>
                    :
                    <div class="noDataContainerBillOfLading">
                        <small id="noDataMessageBillOfLading">No result found</small>
                    </div>
                }
                {noRecord ?
                    <div class="csmobilewidth">
                        {
                            (allBillData?.map((name, index) => {
                                return (
                                    <div key={index} onClick={() => onHandleCard(index)}>
                                        {index >= (allBillData.length / 2) && <div className='cs2card2'>
                                            <small id="ContainerNo">Container No.</small>
                                            <div className='cs2terminalNameCol1'>
                                                {name?.containerNumber}
                                                <a id="arrowleft"><img src={rightArrow} width="23" height="23" class=" pt-1" alt="" loading="lazy" /></a>
                                            </div>
                                        </div>
                                        }
                                    </div>
                                );
                            }))}
                    </div>
                    :
                    null
                }
                <div class="cs2footer22">
                    <Footer2 />
                </div>
            </div>
            <div class="cs2footer11">
                <Footer />
            </div>
        </div>
    );
};
export default ContainerStatusBillOfLading;